import {
  firestore,
  storageRef,
  functions,
  firestoreField,
  firestoreDb,
  realtimeDb,
} from "@/config/firebase";
import { showMessage } from "@/services/MessageService";
import { i18n } from "@/i18n";
import { SET_TICKETS_AVAILABLE } from "./mutation-types";
import store from "@/store";
import { generateQR } from "@/services/qr";
export default {
  async registerParticipant({ rootState, dispatch }: any, userData) {
    if (rootState.user.data) {
      const result = await saveParticipantData(userData);
      if (result) dispatch("user/validRegister", userData, { root: true });
    }
  },
  /**
   * Add and update counters in participant registration statistics.
   * @param {Object} eventData contains the eventID and the type to know what the movement is according to the pending and paid cases
   */
  async counterStatisticsParticipant({ _ }: any, eventData) {
    try {
      const increment = firestoreField.increment(1);
      const decrement = firestoreField.increment(-1);
      const participantRef = await firestore("events")
        .doc(eventData.eventID)
        .collection("stats")
        .doc("participants");
      const batch = firestoreDb.batch();
      switch (eventData.type) {
        case "participantPending":
          batch.set(
            participantRef,
            { participantPendign: increment },
            { merge: true }
          );
          break;
        case "participantPaid":
          batch.set(
            participantRef,
            { participantPaid: increment },
            { merge: true }
          );
          batch.set(
            participantRef,
            { participantPendign: decrement },
            { merge: true }
          );
          break;
        default:
      }
      batch.commit();
    } catch (e) {
      showMessage({
        title: i18n.global.t("register.registerError.title"),
        message: i18n.global.t("register.registerError.message"),
        type: "error",
      });
      return false;
    }
  },
  /**
   * Add and update the counter  in the stats to bookings.
   * @param {Object} eventID contains the ID of event
   */
  async counterStatisticsBookings({ _ }: any, eventID) {
    try {
      const increment = firestoreField.increment(1);
      const bookingRef = await firestore("events")
        .doc(eventID)
        .collection("stats")
        .doc("bookings");
      const batch = firestoreDb.batch();
      batch.set(bookingRef, { bookingsCompleted: increment }, { merge: true });
      batch.commit();
    } catch (e) {
      showMessage({
        title: i18n.global.t("register.registerError.title"),
        message: i18n.global.t("register.registerError.message"),
        type: "error",
      });
      return false;
    }
  },
  /**
   * Add and update the counter daily in the stats to tickets.
   *
   */
  async counterStatisticsTickets({ _ }: any) {
    try {
      const increment = firestoreField.increment(1);
      const date = new Date();
      const ticketID = store.getters["user/participantData"].ticketType;
      const eventID = store.getters["user/eventData"].id;
      const batch = firestoreDb.batch();
      const ticketGeneralRef = await firestore("events")
        .doc(eventID)
        .collection("stats")
        .doc("tickets");

      const ticketsRef = await firestore("events")
        .doc(eventID)
        .collection("stats")
        .doc("tickets")
        .collection("daily")
        .doc(date.toDateString());

      batch.set(
        ticketsRef,
        { date: date, [ticketID]: increment },
        { merge: true }
      );
      batch.set(ticketGeneralRef, { [ticketID]: increment }, { merge: true });
      batch.commit();
      return true;
    } catch (e) {
      showMessage({
        title: i18n.global.t("register.registerError.title"),
        message: i18n.global.t("register.registerError.message"),
        type: "error",
      });
      return false;
    }
  },
  /**
   * Add and update the counter daily in the stats to new participants.
   *
   *
   */
  async counterStatisticsNewParticipants({ _ }: any) {
    try {
      const increment = firestoreField.increment(1);
      const date = new Date();
      const eventID = store.getters["user/eventData"].id;
      const batch = firestoreDb.batch();

      const participantsRef = await firestore("events")
        .doc(eventID)
        .collection("stats")
        .doc("participants")
        .collection("daily")
        .doc(date.toDateString());

      batch.set(
        participantsRef,
        { date: date, newParticipants: increment },
        { merge: true }
      );
      batch.commit();
      return true;
    } catch (e) {
      showMessage({
        title: i18n.global.t("register.registerError.title"),
        message: i18n.global.t("register.registerError.message"),
        type: "error",
      });
      return false;
    }
  },
  /**
   * Add and update the counter daily in the stats to revenue of tickets.
   * @param {Object} userData contains the eventID and subTotal to increment counter according to the sold
   */
  async counterStatisticsRevenueTickets({ _ }: any, userData) {
    try {
      const increment = firestoreField.increment(userData.subTotal);
      const date = new Date();
      const batch = firestoreDb.batch();
      const revenueGeneralTicketsRef = await firestore("events")
        .doc(userData.eventID)
        .collection("stats")
        .doc("revenue");
      const revenueTicketRef = await firestore("events")
        .doc(userData.eventID)
        .collection("stats")
        .doc("revenue")
        .collection("daily")
        .doc(date.toDateString());

      batch.set(
        revenueGeneralTicketsRef,
        { revenueTotalTickets: increment },
        { merge: true }
      );
      batch.set(
        revenueTicketRef,
        { date: date, revenueTickets: increment },
        { merge: true }
      );
      batch.commit();
      return true;
    } catch (e) {
      showMessage({
        title: i18n.global.t("register.registerError.title"),
        message: i18n.global.t("register.registerError.message"),
        type: "error",
      });
      return false;
    }
  },
  /**
   * Add and update the counter daily in the stats to revenue of bookings.
   * @param {Object} userData contains the eventID and subTotal to increment counter according to the sold
   */
  async counterStatisticsRevenueBookings({ _ }: any, userData) {
    try {
      const increment = firestoreField.increment(userData.subTotal);
      const date = new Date();
      const batch = firestoreDb.batch();
      const revenueGeneralBookingsRef = await firestore("events")
        .doc(userData.eventID)
        .collection("stats")
        .doc("revenue");
      const revenueBookingRef = await firestore("events")
        .doc(userData.eventID)
        .collection("stats")
        .doc("revenue")
        .collection("daily")
        .doc(date.toDateString());

      batch.set(
        revenueGeneralBookingsRef,
        { revenueTotalBookings: increment },
        { merge: true }
      );
      batch.set(
        revenueBookingRef,
        { date: date, revenueBookings: increment },
        { merge: true }
      );
      batch.commit();
      return true;
    } catch (e) {
      showMessage({
        title: i18n.global.t("register.registerError.title"),
        message: i18n.global.t("register.registerError.message"),
        type: "error",
      });
      return false;
    }
  },
  async sendEmailToConfirmPayment({ rootState }: any) {
    if (rootState.user.data) {
      const sendEmail = functions.httpsCallable("emailToConfirmPayment");
      await sendEmail({
        ...rootState.user.participantGeneralData,
        ...rootState.user.eventData,
      });
    }
  },
  async registerEventParticipant({ rootState, dispatch }: any, userData) {
    if (rootState.user.data) {
      const result = await saveEventParticipantData({
        ...userData,
        ...rootState.user.participantGeneralData,
      });
      if (result)
        dispatch("user/validRegisterByEvent", userData, { root: true });
      dispatch("counterStatisticsNewParticipants");
      dispatch("counterStatisticsParticipant", {
        eventID: userData.eventID,
        type: "participantPending",
      });
    }
  },
  /**
   * Check availability of the event
   * @param {string} eventID ID of the event that its going to be consulted from database
   * @returns {object} quota information
   */
  async getQuotaEvent({ commit }: any, eventID) {
    const checkQuotaEvent = functions.httpsCallable("checkQuotaEvent");
    const result = await checkQuotaEvent({ eventID: eventID });
    if (result.data === "ticketsAvailable") {
      commit(SET_TICKETS_AVAILABLE, true);
    }
    if (result.data === "ticketsSoldOut") {
      commit(SET_TICKETS_AVAILABLE, false);
    }
  },
  /**
   * Check the certificates availables
   * @param {string} eventID ID of the event that its going to be consulted from database
   * @returns {object} quota information
   */
  async getCertificatesAvailables({ commit }: any) {
    try {
      const eventID = store.getters["user/eventData"].id;
      const getListOfCertificates = functions.httpsCallable(
        "getListOfCertificates"
      );
      const result = await getListOfCertificates({ eventID: eventID });
      return result.data;
    } catch (error) {
      return [];
    }
  },
  async saveCardEventParticipantData({ dispatch }, userData) {
    try {
      const generatedQRImageData = await generateQR({
        uid: userData.uid,
        eventID: userData.eventID,
      });
      await realtimeDb
        .ref(`shallow-participants/${userData.eventID}/${userData.uid}`)
        .set({ name: userData.fullName, uid: userData.uid });
      const participantSaveData = {
        ...userData,
        status: "paid",
        qrCode: generatedQRImageData,
      };
      await firestore("events")
        .doc(userData.eventID)
        .collection("participants")
        .doc(userData.uid)
        .set(participantSaveData);
      dispatch("user/validRegisterByEvent", participantSaveData, {
        root: true,
      });
      dispatch("user/validStatusPay", participantSaveData, { root: true });
      dispatch("user/changeCompleRegisterCard", false, { root: true });
    } catch (error) {
      showMessage({
        title: i18n.global.t("register.registerError.title"),
        message: i18n.global.t("register.registerError.message"),
        type: "error",
      });
    }
  },
};

async function saveParticipantData(userData) {
  try {
    if (userData.profileImage) {
      if (userData.profileImage.includes("data:image")) {
        const profileImage = await storageRef
          .child(`participants/${userData.uid}/profileImage`)
          .putString(userData.profileImage, "data_url");
        const profileImageURL = await profileImage.ref.getDownloadURL();
        userData.profileImage = profileImageURL;
      }
    }
    await firestore("participants").doc(userData.uid).set(userData);

    showMessage({
      title: i18n.global.t("register.registerSuccessUser.title"),
      message: i18n.global.t("register.registerSuccessUser.message"),
      type: "success",
    });
    return true;
  } catch (error) {
    showMessage({
      title: i18n.global.t("register.registerError.title"),
      message: i18n.global.t("register.registerError.message"),
      type: "error",
    });
    return false;
  }
}
async function saveEventParticipantData(userData) {
  try {
    if (userData.optionalFields) {
      for (let field = 0; field < userData.optionalFields.length; field++) {
        if (userData.optionalFields[field].type == "file") {
          delete userData.optionalFields[field].file;
          if (userData.optionalFields[field].value) {
            const fileRef = await storageRef
              .child(
                `events/${userData.eventID}/participants/${userData.uid}/${userData.optionalFields[field].id}`
              )
              .putString(userData.optionalFields[field].value, "data_url");
            const fileURL = await fileRef.ref.getDownloadURL();
            userData.optionalFields[field].value = fileURL;
          }
        }
      }
    }
    await realtimeDb
      .ref(`shallow-participants/${userData.eventID}/${userData.uid}`)
      .set({ name: userData.fullName, uid: userData.uid });
    await firestore("events")
      .doc(userData.eventID)
      .collection("participants")
      .doc(userData.uid)
      .set(userData);

    const addProduct = functions.httpsCallable("addProduct");
    await addProduct({
      eventId: userData.eventID,
      productDocumentPath: `events/${userData.eventID}/tickets/${userData.ticketType}`,
      quantity: 1,
    });
    showMessage({
      title: i18n.global.t("register.registerSuccess.title"),
      message: `${i18n.global.t("register.registerSuccess.message")} ${
        userData.eventName
      }`,
      type: "success",
    });
    return true;
  } catch (error) {
    showMessage({
      title: i18n.global.t("register.registerError.title"),
      message: i18n.global.t("register.registerError.message"),
      type: "error",
    });
    return false;
  }
}
